import { memo, type FC } from 'react';

import {
  Dialog,
  DialogCloseButton,
  DialogContent,
} from '@wwe-portal/ui/components/dialog';
import { cn } from '@wwe-portal/ui/lib/lib';

export interface RosterDialogProps {
  open: boolean;
  onClose?: () => void;
  hidden?: boolean;
  children: React.ReactNode;
  className?: string;
}
export const OfferCardBannerMobileWrapper: FC<RosterDialogProps> = ({
  open,
  onClose,
  hidden,
  className,
  children,
}) => {
  return (
    <Dialog
      onOpenChange={(value) => {
        if (!value) onClose?.();
      }}
      open={open}
    >
      <DialogContent
        className={cn(
          'z-dialog from-back800 to-back600 pointer-events-auto top-1/2 max-h-[calc(100dvh-88px)] w-[calc(100%-32px)] max-w-[362px] -translate-y-[calc(50%-24px)] bg-gradient-to-l md:max-w-[362px] 2xl:max-w-[362px]',
          className
        )}
        data-id="shop-banner-mobile-hover"
        hidden={hidden}
        variant="dialog"
      >
        {children}
        <DialogCloseButton onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default memo(OfferCardBannerMobileWrapper);
